import { NgModule } from '@angular/core';
import { AdminUsersService } from './services/admin-users.service';

@NgModule({
  providers: [AdminUsersService],
})
export class AdminUsersModule {}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/admin-users/admin-users.module.ts